<template>
	<DashboardLayout>
		<!-- <Transition
      :enter-active-class="$style['route-transition--entering']"
      :enter-class="$style['route-transition--enter-start']"
      :enter-to-class="$style['route-transition--enter-end']"
      :leave-active-class="$style['route-transition--exiting']"
      :leave-to-class="$style['route-transition--exit-end']"
      mode="out-in"
    > -->

		<keep-alive :include="cachedViews">
			<RouterView />
		</keep-alive>
		<!-- </Transition> -->
	</DashboardLayout>
</template>
<script>
import DashboardLayout from '@layouts/Dashboard'

// Heavy list views kept alive so back/forward navigation restores them
// instantly instead of rebuilding the whole component tree. Each included
// view refetches its data in activated() and guards its department watcher
// against firing while deactivated.
export default {
	name: 'DashboardView',
	components: {
		DashboardLayout
	},
	data () {
		return {
			cachedViews: ['ShipmentsView', 'CollectionsView', 'TasksView']
		}
	}
}
</script>
<style lang="scss" module>
// .route-transition {
	// 	&--entering {
	// 		transition: opacity 0.1s linear, transform 0.12s cubic-bezier(0, 0, 0.2, 1);
	// 		transform-origin: center;
	// 		will-change: opacity, transform;
	// 	}
	// 	&--enter-start {
	// 		// transform: scale(0);
	// 		opacity: 0;
	// 	}
	// 	&--enter-end {
	// 		// transform: scale(1);
	// 		opacity: 1;
	// 	}
	// 	&--exiting {
	// 		transition: opacity 0.1s linear;
	// 	}
	// 	&--exit-start {
	// 	}
	// 	&--exit-end {
	// 		opacity: 0;
	// 	}
	// }
</style>
